import { connect } from 'react-redux';

import { selectors, actionCreators } from 'dux/user';
import MFACard from './MFACard';

const mapStateToProps = (state) => ({
  enrollmentId: selectors.getIdentityState(state).enrollmentId,
});

const mapDispatchToProps = {
  startMFASignupFlow: actionCreators.startMFASignupFlow,
  getMFAStatus: actionCreators.getMFAStatus,
  removeMFAEnrollment: actionCreators.removeMFAEnrollment,
};

export default connect(mapStateToProps, mapDispatchToProps)(MFACard);
